import type { UndoRedoResponse } from "@/types/action"
import type { Timestamp } from "@/types/date"
import type {
  ItineraryEvent,
  ItineraryEventProperties,
  ItineraryEventType,
} from "@/types/itinerary"
import type { Place } from "@/types/place"
import type { TravelerGroup } from "@/types/trip"

export interface AddPlaceItineraryEventActionInput {
  place: Place
  start: Timestamp
  end?: Timestamp
  travelers?: TravelerGroup
  defaultTime?: boolean
  allDay?: boolean
  updateTripTimeFrame?: boolean
  scheduled?: boolean
}

export interface AddCustomItineraryEventActionInput {
  type: ItineraryEventType
  place?: Place
  endPlace?: Place
  title?: string
  user_note?: string
  travelers?: TravelerGroup
  properties?: ItineraryEventProperties
  timeZone: string
  endTimeZone?: string
  start: Timestamp
  end?: Timestamp
  defaultTime?: boolean
  allDay?: boolean
  updateTripTimeFrame?: boolean
  scheduled?: boolean
  messageId?: number
  webSearchResultId?: string
}

export interface UpdateItineraryEventActionInput {
  event: ItineraryEvent
  newPlace?: Place
  newEndPlace?: Place
  newStart?: Timestamp
  newEnd?: Timestamp
  newAllDay?: boolean
  newTimeZone?: string
  newEndTimeZone?: string
  newTravelers?: TravelerGroup
  newType?: ItineraryEventType
  newTitle?: string
  newUserNote?: string
  newProperties?: ItineraryEventProperties
  newScheduled?: boolean
  updateTripTimeFrame?: boolean
}

export type ItineraryEventActionResponse =
  | {
      event: ItineraryEvent
      toastMessage: string | undefined
    }
  | undefined

export type AddItineraryEventActionResponse = ItineraryEventActionResponse
export type RemoveItineraryEventActionResponse = ItineraryEventActionResponse
export type UpdateItineraryEventActionResponse = ItineraryEventActionResponse

export type ClearItineraryActionResponse =
  | { toastMessage: string | undefined }
  | undefined

export type UndoRedoResponseAndMessage = {
  response: UndoRedoResponse | undefined
  toastMessage: string | undefined
}

export const UIWhereChat = "chat"
export const UIWhereCalendar = "calendar"
export const UIWhereFolio = "folio"

export type UIWhere =
  | typeof UIWhereChat
  | typeof UIWhereCalendar
  | typeof UIWhereFolio
